function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "elotech-contabil",
  d: "M167.224,207.864a6.722,6.722,0,1,1,13.444,0v35.595a46.441,46.441,0,0,0,13.444,3.975V220.281a6.722,6.722,0,1,1,13.443,0v27.075A46.491,46.491,0,0,0,221,243.167V187.724a6.722,6.722,0,1,1,13.444,0v45.56a46.739,46.739,0,1,0-67.218.649Z",
  transform: "translate(-153.78 -154.4)"
});

const SvgLogoOxyContabil = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 93.485,
    height: 93.034,
    viewBox: "0 0 93.485 93.034",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLogoOxyContabil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-oxy-contabil.533b3583.svg";
export { ForwardRef as ReactComponent };